import OTPForm from "../../components/auth/forms/OTPForm";

const OTPVerifyPage = () => {

  return (
    <OTPForm />
  );
};

export default OTPVerifyPage;
